import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { scrollbarDarkThin2 } from "UI/scrollbarStyles";

import Report from "./Report";

UserDonorSummaries.propTypes = {
  householdID: PropTypes.number,
  reports: PropTypes.array,
  style: PropTypes.object,
};

export default function UserDonorSummaries({
  householdID,
  reports = [],
  style,
}) {
  const sortedReports = reports?.sort((a, b) => b.year - a.year);

  return (
    <Wrapper style={style}>
      {sortedReports?.map((report) => {
        return (
          <Report
            key={report.reportID}
            report={report}
            householdID={householdID}
          />
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-right: 16px;
  padding-top: 26px;
  overflow-y: auto;

  ${scrollbarDarkThin2}
  &::-webkit-scrollbar-track {
    margin: 20px 0;
  }
`;
